import { url } from "./ApiUrl";

//NOT a file url!
export const datasetImageThumbnailUrl = ( datasetImageId: number, size: number = 256 ): string => {
    return url( `/api/dataset/image/${datasetImageId}/thumbnail?resolution=${size}` );
}; 

export const fileUrl = ( filePath: string ): string => {
    return url( `/api/files/${filePath}` );
}

export const thumbnailUrl = ( aerialImageId: number, size: number = 256 ): string => {
    return fileUrl( `aerial/thumbnails/${aerialImageId}-${size}.jpg` );
};

export const vehicleThumbnailBefore = ( abandonedVehicleId: number ): string => {
    return fileUrl( `vehicle/${abandonedVehicleId}a.png` );
};

export const vehicleThumbnailAfter = ( abandonedVehicleId: number ): string => {
    return fileUrl( `vehicle/${abandonedVehicleId}b.png` );
};

export const aerialImageUrl = ( aerialImageId: number ): string => {
    return fileUrl( `aerial/${aerialImageId}` );
};

export const aerialImageUrlName = ( name: string ): string => {
    return fileUrl( `aerial/${name}` );
};

export const aerialImageTileSpec = ( aerialImageId: number ): string => {
    return fileUrl( `tile/${aerialImageId}/{z}/{x}-{y}.png` );
};

export const datasetImageUrl = ( datasetId: number, datasetImageId: number ): string => {
    return fileUrl( `dataset/${datasetId}/${datasetImageId}.png` );
};
